<template>
  <InsideContent
    :title="reviewTitle"
    :hint="$t('HINTS.APPS.REVIEWS')"
    icon="<i class='material-icons'>comment</i>"
  >
    <RateSummary />

    <WithManualPagination
      :show-pagination="!reviewsLoading"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="count"
      @size-change="setPageSize"
      @current-change="setCurrentPage"
    >
      <CardApiError
        v-if="apiError"
        :error-text="$t('APP.REVIEWS.API_ERROR')"
        @retry="getReviews"
      />

      <Card v-else :is-loading="reviewsLoading" no-padding>
        <ReviewsFilter
          :applied-filters="appliedFilters"
          @set-filters="setAppliedFilters"
          @reset-filters="resetFilters"
        />

        <ReviewsList
          :reviews="reviews"
          :is-filtered="Boolean(appliedFilters)"
        />
      </Card>
    </WithManualPagination>
  </InsideContent>
</template>

<script>
import Reviews from '@/api/app-reviews';
import pagination from '@/mixins/pagination';
import modal from '@/mixins/modal';
import packageNameWatch from '@/mixins/apps/packageNameWatch';
import packageNameMixin from '@/mixins/packageName';
import InsideContent from '@@/common/layout/InsideContent';
import { label } from '@/utils/number';
import RateSummary from './RateSummary';
import CardApiError from '@@/common/CardApiError';
import Card from '@@/common/Card';
import ReviewsFilter from './ReviewsFilter';
import ReviewsList from './ReviewsList';
import WithManualPagination from '@@/common/paginations/WithManualPagination';
export default {
  name: 'AppReviews',

  components: {
    InsideContent,
    CardApiError,
    RateSummary,
    Card,
    ReviewsFilter,
    ReviewsList,
    WithManualPagination,
  },

  mixins: [pagination, modal, packageNameWatch, packageNameMixin],

  data() {
    return {
      reviews: [],
      reviewsLoading: false,
      count: 0,
      currentPage: 1,
      pageSize: 20,
      showFilterModal: false,
      appliedFilters: null,
      apiError: false,
    };
  },

  computed: {
    pageSizes() {
      return this.getPageSizes(this.count);
    },

    filters() {
      return {
        offset: this.pageSize * (this.currentPage - 1),
        limit: this.pageSize,
        ...this.appliedFilters,
      };
    },

    reviewTitle() {
      return label(
        this.count,
        this.$t('APP.REVIEWS.REVIEWS_TITLE'),
        this.$t('APP.REVIEWS.NO_REVIEWS_TITLE'),
      );
    },
  },

  watch: {
    appliedFilters() {
      this.getReviews();
    },
  },

  created() {
    this.getInfo();
  },

  methods: {
    getInfo() {
      this.getReviews();
    },

    getReviews() {
      this.apiError = false;
      this.reviewsLoading = true;
      return Reviews.getReviews({
        packageName: this.packageName,
        filters: this.filters,
      })
        .then(({ reviews, count }) => {
          this.reviews = reviews;
          this.count = count;
        })
        .catch(({ message }) => {
          this.$message.error(message);
          this.apiError = true;
        })
        .finally(() => {
          this.reviewsLoading = false;
        });
    },

    setCurrentPage(page) {
      this.currentPage = page;
      this.getReviews();
    },

    setPageSize(size) {
      this.pageSize = size;
      this.getReviews();
    },

    setAppliedFilters(appliedFilters) {
      this.appliedFilters = appliedFilters;
    },

    resetFilters() {
      this.appliedFilters = null;
    },
  },
};
</script>
